'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _Player = require('../sprites/Player');

var _Player2 = _interopRequireDefault(_Player);

var _Man = require('../sprites/Man');

var _Man2 = _interopRequireDefault(_Man);

var _Native = require('../sprites/Native');

var _Native2 = _interopRequireDefault(_Native);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* globals __DEV__ */


var _class = function (_Phaser$State) {
  _inherits(_class, _Phaser$State);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'init',
    value: function init() {
      this.stage.backgroundColor = '#66c3ff';
    }
  }, {
    key: 'create',
    value: function create() {
      // create the raft that the player controls
      var raft_x = 32;
      var raft_y = 32;
      this.raft = this.game.add.sprite(raft_x, raft_y, 'sprites');
      this.raft.frameName = 'raft';
      this.raft.anchor.setTo(0.5, 1.0);

      // place men on the raft
      var pos = [[-5, -5], [5, -5], [-2, -3], [2, -1]];
      this.man = null;
      for (var i = 0; i < _config2.default.player.lives; i++) {
        var _pos$i = _slicedToArray(pos[i], 2),
            x = _pos$i[0],
            y = _pos$i[1];

        this.man = this.game.add.sprite(x + raft_x, y + raft_y, "sprites");
        this.man.anchor.setTo(0.5, 1.0);
        this.man.frameName = 'frontiersman';
      }

      // place native and tween him across the screen
      this.enemy = this.game.add.sprite(48, this.man.y, "sprites");
      this.enemy.anchor.setTo(0.5, 1.0);
      this.enemy.frameName = 'native_3';
      this.timer = 5.0;
      this.tween = null;
    }
  }, {
    key: 'render',
    value: function render() {}
  }, {
    key: 'update',
    value: function update() {
      var dt = this.game.time.physicsElapsed;
      this.timer -= dt;

      if (this.timer < 4.0 && this.tween == null) {
        this.tween = this.game.add.tween(this.enemy).to({ x: this.man.x + 5 });
        this.tween.start();
        this.tween.onComplete.add(this.goBack, this);
      }

      if (this.timer <= 0.0) {
        _config2.default.player.lives -= 1;
        if (_config2.default.player.lives <= 0) this.state.start("GameOver");else this.state.start("Game");
      }
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      console.log("go back");
      this.man.x = 0;
      this.man.y = 0;
      this.enemy.addChild(this.man);
      var tween = this.game.add.tween(this.enemy).to({ x: 100 }, 2000);
      tween.start();
    }
  }]);

  return _class;
}(_phaser2.default.State);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/states/Hit.js
// module id = 317
// module chunks = 0